export const swiperMixin = {
  methods: {
    mySlideTo ( index ) {
      this.$store.dispatch('setNowPage', index)
    },

    showDetails ( index ) {
      this.$emit('showDetails', index)
    },

    showPpersonalInfo ( val ) {
      this.$emit('showPpersonalInfo', val)
    },

    changeShowAnimal ( showNow ) {
      this.showNow = showNow
      this.$store.dispatch('setNextBtn', false)
    },
  },
}